import Vue from 'vue'

Vue.prototype.$itemsRequestLimit = 200
